<template>
    <v-dialog v-model="dialogMentionLegal" scrollable max-width="450px">
        <v-btn class="black mt-5 white--text"
               dark
               large slot="activator">Mentions légales
        </v-btn>
        <v-card>
            <v-card-title class="headline">Mentions légales</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 400px;">
                <strong>Propriétaire</strong>
                <br/>Propriétaire du site : M. Eric GRUX
                <br/>Siret : 843 200 718 00016
                <br/>Immatriculation 843 200 718 R.C.S. Besancon
                <br/>S.A.S.U. au capital de 5 000 EUROS
                <br/>Siege Social : 28B rue François Arago 25000 BESANÇON
                <br/>
                <br/><strong>Création du site internet</strong>
                <br/>Jinic-Média – Votre partenaire pour le web et vos événements ludiques
                <br/>28B rue François Arago
                <br/>25000 Besançon
                <br/>
                <br/><strong>Hébergement</strong>
                <br/>OVH
                <br/>SAS au capital de 10 069 020 €
                <br/>RCS Lille Métropole 424 761 419 00045
                <br/>Code APE 2620Z
                <br/>N° TVA : FR 22 424 761 419
                <br/>Siège social : 2 rue Kellermann - 59100 Roubaix - France
                <br/>
                <br/><strong>Loi informatique et libertés</strong>
                <br/>Conformément à la loi Informatique et libertés du 6 janvier 1978, nous vous informons que vous
                disposez d’un droit d’accès, de modification, de rectification et de suppression de votre contribution.
                Pour cela, écrivez au siège de la société. Formulaire de contact Les informations recueillies auprès des
                personnes par le biais du formulaire de contact ne sauraient être divulguées à des personnes autres que
                celles composant notre collectivité. Toutefois, tel que l’exige la loi Informatique et Libertés nous
                vous informons que vos réponses sont facultatives et que le défaut de réponse n’entraînera aucune
                conséquence particulière. Néanmoins, vos réponses doivent être suffisantes pour nous permettre de
                traiter l’information.
                <br/>
                <br/><strong>Contrefaçon</strong>
                <br/>Toute reproduction ou représentation, en tout ou partie, à d'autres fins sur un quelconque support
                est interdite. Le non-respect de cette interdiction constitue une contrefaçon pouvant engager la
                responsabilité civile et pénale du contrefacteur. Les informations contenues dans ce service sont non
                contractuelles et sujettes à modification sans préavis.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogMentionLegal=false" aria-label="Fermer">
                    <v-icon size="24px">fas fa-window-close</v-icon>
                    &nbsp;Fermer
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "MentionsLegales",
        data() {
            return {}
        },
        methods: {
            toggleDisplay() {
                this.dialogMentionLegal = !this.dialogMentionLegal;
            }
        },
        computed: {
            dialogMentionLegal: {
                get() {
                    return this.$store.state.dialogMentionLegal
                },
                set(value) {
                    this.$store.commit('showMentionLegal', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>